import React, {Component} from 'react';
import Project_3 from './Project_3'; 
import Project_4 from './Project_4';
import Project_5 from './Project_5';
import Project_6 from './project_6';
import Project_7 from './project_7';
import Project_8 from './Project_8';

class Project_2 extends Component {
    render(){
        return(
            <div>
                <Project_5/>   
                <Project_7/>
                <Project_4/>   
                <Project_6/> 
                <Project_8/>  
            </div>


        )


    }


}

export default Project_2; 